import Header from "Shared/Header";
import Sidebar from "Shared/Sidebar";
import logo from "Assets/trade-india-logo.svg";
import "../index.css";

const Layout = ({ component }) => {
    return (
        <>
            <div
                className="w-full overflow-hidden"
                style={{
                    background:
                        "linear-gradient(180deg, rgba(2, 0, 40, 1) 0%, rgba(1, 0, 75, 1) 49%, rgba(2, 0, 95, 1) 65%, rgba(2, 0, 120, 1) 100%)",
                }}
            >
                <div className="z-50 top-0">
                    <Header />
                </div>
                <div className="grid grid-cols-[300px_1fr] bg-white h-[93vh] overflow-hidden">
                    <Sidebar />

                    <div
                        className="text-gray-400 w-full bg-slate-100 overflow-y-auto h-[93vh] p-4"
                    >
                        {component}
                        <a href="https://tradeindia.com/" target="_blank" rel="noreferrer" >
                            <div className="absolute z-50 text-center !bottom-0 !bg-slate-50 shadow shadow-red-400 opacity-100 power rounded p-1 !right-0 m-1 text-sm">
                                <img src={logo} className="h-8 mx-auto w-40" alt={"layout"} />
                                Powered By ERP
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Layout;
